import HelpLink from 'App/HelpLink';
import { DEFAULT_LANGUAGE, HELP_LINKS_SUBSCRIPTIONS } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

export function SubscriptionsHelpLink() {
  const t = useTranslationCatalog();
  const language = useTranslationLanguage();

  return (
    <HelpLink
      title={t('helpLink.aboutSubscriptions')}
      linkURL={
        HELP_LINKS_SUBSCRIPTIONS[language] ??
        HELP_LINKS_SUBSCRIPTIONS[DEFAULT_LANGUAGE]
      }
      icon="both"
      currentViewTracking={t('helpLink.aboutSubscriptionsTrackingName')}
      previousValue="subscriptions_list"
      showInMobile
    />
  );
}
